<div class="nh-toolbar">
  <div class="nh-actions">
    <p-select
      class="nh-topic-select"
      [options]="categoryOptions"
      [(ngModel)]="selectedCategory"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      [style]="{ height: '36px', fontSize: '13px', width: '160px' }"
      (onChange)="onCategoryChange()" />
    <div class="nh-search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="text" [ngModel]="searchText" (ngModelChange)="onSearchChange($event)" placeholder="Search..." />
    </div>
  </div>
</div>

@if (loading() && groups().length === 0) {
  <div class="nh-loading"><i class="fa-solid fa-spinner fa-spin"></i></div>
} @else if (groups().length === 0) {
  <div class="nh-empty">No notifications found.</div>
} @else {
  <div class="nh-list">
    @for (group of groups(); track group.label) {
      <div class="nh-group-label">{{ group.label }}</div>
      @for (item of group.items; track item.id) {
      <div class="nh-item" [class.unread]="!item.isRead">
        <div class="nh-item-indicator" [class]="categoryClass(item.category)"></div>
        <div class="nh-item-content">
          <div class="nh-item-top">
            <div class="nh-item-title-row">
              <span class="nh-item-title">{{ item.title }}</span>
              @if (item.audienceType) {
                <span class="nh-badge nh-badge-audience">{{ audienceLabel(item.audienceType) }}</span>
              }
            </div>
            <div class="nh-item-right">
              <span class="nh-item-time">{{ timeAgo(item.createdAt) }}</span>
              @if (item.status) {
                <span class="nh-badge nh-badge-status" [class]="'status-' + item.status.toLowerCase()">{{ item.status }}</span>
              }
            </div>
          </div>
          <p class="nh-item-body">{{ item.body }}</p>
        </div>
      </div>
      }
    }

    @if (hasNext) {
      <div class="nh-load-more">
        <button (click)="loadMore()" [disabled]="loading()">
          @if (loading()) { <i class="fa-solid fa-spinner fa-spin"></i> } @else { Load more }
        </button>
      </div>
    }
  </div>
}
